/** @format */

import { selectorBookingRoom } from '@/ducks/booking/selectors';
import { TLocale } from '@/utils/gatsby/types';
import { IntlContextConsumer } from 'gatsby-plugin-intl';
import React, { memo, useCallback } from 'react';
import styled from 'styled-components';
import { TOtherPaths } from '../../../@ducks/filters/declarations';
import { selectorCurrentPage } from '../../../@ducks/general/selectors';
import { useAppTranslation } from '../../../i18n/declarations';
import { useAppSelector } from '../../../redux/hooks';
import { utilityGetLocaleURL, utilityGetLocaleUrlRoom } from '../../../utils/helpers/getLocaleURL';

// #region ::: COMPONENTS

interface PropsButtonLocaleMobile {
  isSelected: boolean;
}

const ButtonLocaleMobile = styled.button<PropsButtonLocaleMobile>`
  color: ${({ isSelected }) => (isSelected ? '#eee' : '#7e7e7a')};
  font-family: ${({ theme }) => theme.font.body};
  font-size: 20px;
  font-weight: 700;
  border: none;
  background: none;
  width: 100%;
  text-align: center;
  cursor: ${({ isSelected }) => (isSelected ? 'not-allowed' : 'pointer')};
  padding: 5px 10px;
`;
// #endregion

interface Props {
  otherPaths: TOtherPaths;
}
export const SwitchLocaleMobile = memo(({ otherPaths }: Props) => {
  const { intl } = useAppTranslation();
  const room = useAppSelector(selectorBookingRoom);
  const currentPage = useAppSelector(selectorCurrentPage);

  const handleClick = useCallback(
    (locale: TLocale) => {
      const hasQueryParams =
        currentPage === 'booking' ||
        currentPage === 'request-visit' ||
        currentPage === 'request-info' ||
        currentPage === 'request-info-received' ||
        currentPage === 'request-visit-confirmed';

      document.location.href = hasQueryParams
        ? utilityGetLocaleUrlRoom({ room, locale: intl.locale as TLocale })
        : utilityGetLocaleURL(locale, otherPaths);
    },
    [currentPage],
  );

  return (
    <IntlContextConsumer>
      {({ languages, language }) => (
        <div style={{ position: 'relative', padding: '20 10px', display: 'flex' }}>
          {languages.map(locale => {
            const isSelected = locale === language;

            return (
              <ButtonLocaleMobile
                disabled={isSelected}
                isSelected={isSelected}
                key={locale}
                onClick={() => handleClick(locale as TLocale)}
              >
                {locale.toUpperCase()}
              </ButtonLocaleMobile>
            );
          })}
        </div>
      )}
    </IntlContextConsumer>
  );
});
